module.exports = __webpack_public_path__ + "static/media/uisce.823d2015.png";